import React, { memo, useEffect, useState } from "react";
import moment from "moment";
import Message from "../../../../components/Message/Message";

const RestTimeToResendCodeMessage = ({ timeForRepeatCode }) => {
	const [now, setNow] = useState(null);
	const restOfTime = moment(timeForRepeatCode).diff(now, "s");
	useEffect(() => {
		const interval = setInterval(() => {
			setNow(moment());
		}, 1000);
		return () => clearInterval(interval);
  }, []);
	if (!restOfTime) {
		return null;
	}
	return (
		<Message
			info={`Вам на почту придет код для подтверждения. Отправить повторно можно через ${restOfTime} секунд`}
		/>
	);
};
export default memo(RestTimeToResendCodeMessage);
